import React from 'react';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { OverlapPartner } from '../partners/partners.component';
import { HeaderOverlap } from '../../../components/essentials/bar-component/bar.component';
import playing from '../../../assest/15 - About - Company/About Page.jpg';
import '../../../components/essentials/bar-component/bar.styles.scss';
import './about-earthid.styles.scss';
import linkedin from '../../../assest/Home/LinkedIn.png';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';
import { useTranslation } from 'react-i18next';

export const AboutEarthId = () => {
  const { t } = useTranslation('about-earthid');

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />
      <OverlapPartner title={t('headerTitle')}>
        <TrackedSection sectionName="About-Company Header Overlap">
          <div className='content-partners about-company'>
            <div className='text-content-partner'>
              <div className='text-content-block'>
                <p className='text-content-earth'>{t('section1')}</p>
                <p className='text-content-earth'>{t('section2')}</p>
                <p className='text-content-earth'>{t('section3')}</p>
                <p className='text-content-earth'>{t('section4')}</p>
                <p className='text-content-earth'>{t('section5')}</p>
              </div>
            </div>
            <img src={playing} className='img-for-company' alt='partner-img' />
          </div>
        </TrackedSection>
      </OverlapPartner>

      <TrackedSection sectionName="About-Company Decentralized Identity">
        <div className='header-overlap-earthid'>
          <HeaderOverlap
            title={t('sectionOverlapTitle')}
            platform={t('sectionOverlapPlatform')}
            kyc={t('sectionOverlapDesc')}
            url={t('sectionOverlapLink')}
          />
        </div>
      </TrackedSection>

      <EarthidBox title='Thought Leadership' />
      <Getstarted />
      <Footer />
    </div>
  );
};

const EarthidBox = props => {
  return <></>; // Placeholder for future content or leadership profiles
};

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-about'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
          About / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

export const MediumCard = ({ icon, desc, title, profileUrl, description }) => {
  return (
    <div className='leadership-profile'>
      <img src={icon} className='profile-icon' alt='[profile]' />
      <p className='profile-title'>{title}</p>
      <p className='profile-desc'>{desc || 'right now description is not available'}</p>
      <p className='profile-desc-cont'>{description || 'right now description is not available'}</p>
      <a href={profileUrl} className='linkedInIcon' target='_new' rel='noreferrer'>
        <img src={linkedin} alt='LinkedIn profile' />
      </a>
    </div>
  );
};
